import { btnsTitle } from '@aytm/app/stats/page/question-views/ra/lib/utils'

/**
 * Transform answerVariants + answer into batches + hcAnswers for stacked view.
 *
 * Mirrors `rapid_association/chart.coffee` (lines 84–113):
 *   - each answerVariant becomes a "batch" with synthetic sub-answers
 *     [Yes, No, Timed Out] (label text driven by `btnsType`)
 *   - hcAnswers[bN] holds the aggregated values plus a1/a2/a3 sub-answers
 *
 * The synthetic sub-answers + b-keyed answers feed the existing
 * `stacked_*` chart builders (which expect the same shape as Matrix).
 */
export const buildStackedHcAnswers = (answerVariants, answer, btnsType) => {
  const title = btnsTitle(btnsType)
  const titleNA = btnsTitle('timedout')

  const batches = []
  const hcAnswers = {}

  for (const av of answerVariants) {
    const bKey = `b${av.position}`
    hcAnswers[bKey] = { amount: 0, percents: 0 }

    if (!answer) continue

    const answerData = answer[`a${av.position}`]
    if (!answerData) continue

    batches.push({
      ...av,
      answerVariants: [
        { position: 1, text: title.y },
        { position: 2, text: title.n },
        { position: 3, text: titleNA.y }
      ]
    })

    hcAnswers[bKey] = {
      amount: answerData.amount,
      percents: answerData.percents,
      respPercents: answerData.percents,
      a1: { ...answerData.y, respPercents: answerData.y.percents },
      a2: { ...answerData.n, respPercents: answerData.n.percents },
      a3: { ...answerData.na, respPercents: answerData.na.percents }
    }
  }

  return { batches, hcAnswers }
}
